<template>
  <div class="article-two-images-container" :class="containerClasses">
    <div class="article-two-images" :class="classes">
      <div v-if="productHandleTwo" class="TileContainer ImageOneContainer">
        <AddFromPhoto
          :product-handle="productHandleTwo"
          :image-url="imageOne"
        />
      </div>
      <div v-else class="ImageOneContainer">
        <Picture :images="imageOne" />
        <div v-if="handle" class="handle">{{ handle }}</div>
        <div v-if="headings" class="title">
          <h4 class="title__text">
            {{ headings.title1 }}<span>{{ headings.title2 }}</span>
          </h4>
        </div>
      </div>
      <div>
        <div v-if="productHandle" class="TileContainer ImageTwoContainer">
          <AddFromPhoto :product-handle="productHandle" :image-url="imageTwo" />
        </div>
        <div v-else class="ImageTwoContainer">
          <Picture :images="imageTwo" />
          <div v-if="credit" class="credit">{{ credit }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromPhoto from "@/components/AddFromPhoto.vue";
export default {
  name: "ArticleTwoImages",
  components: {
    Picture,
    AddFromPhoto,
  },
  props: {
    imageOne: {
      type: Object,
      required: true,
    },
    imageTwo: {
      type: Object,
      required: true,
    },
    productHandle: {
      type: String,
      default: null,
    },
    productHandleTwo: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
    split: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Boolean,
      default: false,
    },
    stepImageOne: {
      type: Boolean,
      default: false,
    },
    handle: {
      type: String,
      default: null,
    },
    credit: {
      type: String,
      default: null,
    },
    withText: {
      type: Boolean,
      default: false,
    },
    imageOneCenter: {
      type: Boolean,
      default: false,
    },
    imageTwoCenter: {
      type: Boolean,
      default: false,
    },
    imageOneWide: {
      type: Boolean,
      default: false,
    },
    imageTwoWide: {
      type: Boolean,
      default: false,
    },
    gradient: {
      type: Boolean,
      default: false,
    },
    rowGap10px: {
      type: Boolean,
      default: false,
    },
    columnGap10px: {
      type: Boolean,
      default: false,
    },
    block10px: {
      type: Boolean,
      default: false,
    },
    headings: {
      type: Object,
      default: null,
    },
    noGap: {
      type: Boolean,
      default: false,
    },
    block2px: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerClasses() {
      return {
        "article-two-images-container--block": this.block,
        "article-two-images-container--block2px": this.block2px,
        "article-two-images-container--block10px": this.block10px,
        "article-two-images-container--withText": this.withText,
        "article-two-images--split": this.split,
      };
    },
    classes() {
      return {
        "article-two-images-container--block": this.block,
        "article-two-images--rowGap10px": this.rowGap10px,
        "article-two-images--columnGap10px": this.columnGap10px,
        "article-two-images--noGap": this.noGap,
        "article-two-images--split": this.split,
        "article-two-images--step": this.step,
        "article-two-images--stepImageOne": this.stepImageOne,
        "article-two-images--imageOneCenter": this.imageOneCenter,
        "article-two-images--imageTwoCenter": this.imageTwoCenter,
        "article-two-images--imageOneWide": this.imageOneWide,
        "article-two-images--imageTwoWide": this.imageTwoWide,
        "article-two-images--gradient": this.gradient,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-two-images-container {
  margin: 0 auto 60px;

  @include respond-above(md) {
    padding: 0 20px;
    max-width: 1600px;
    grid-template-columns: repeat(2, 1fr);
    margin: 0 auto 80px;
  }

  &--block {
    margin: 0 auto 2px;

    @include respond-above(md) {
      margin: 0 auto 0;
    }
  }
  &--block2px {
    margin: 0 auto 0px;

    @include respond-above(md) {
      margin: 0 auto 2px;
    }
  }
  &--block10px {
    margin: 0 auto 10px;
  }

  &--withText {
    margin: 0 auto 20px;
  }

  &:deep(.picture__wrapper) {
    display: block;
  }
}
.article-two-images {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2px;

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    margin: 0 auto;
    max-width: 1600px;
    row-gap: 0;
  }

  &--split {
    column-gap: 2px;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 0;

    @include respond-above(md) {
      column-gap: 20px;
    }
  }
  &--step {
    .ImageTwoContainer {
      margin-top: 50px;
    }

    @include respond-above(md) {
      column-gap: 40px;
      .ImageTwoContainer {
        margin: 150px 0 0 0;
      }
    }
  }

  &--stepImageOne {
    .ImageOneContainer {
      margin-top: 50px;
    }

    @include respond-above(md) {
      column-gap: 40px;
      .ImageOneContainer {
        margin: 150px 0 0 0;
      }
    }
  }

  &--imageOneCenter {
    .ImageOneContainer {
      display: flex;
      align-items: center;
    }
  }

  &--imageTwoCenter {
    .ImageTwoContainer {
      display: flex;
      align-items: center;
    }
  }

  &--imageOneWide {
    @include respond-above(md) {
      grid-template-columns: 1.762fr 1fr;
    }
  }

  &--imageTwoWide {
    @include respond-above(md) {
      grid-template-columns: 1fr 1.762fr;
    }
  }

  &--rowGap10px {
    row-gap: 10px;
  }

  &--columnGap10px {
    column-gap: 10px;
  }

  &--noGap {
    row-gap: 0;
    column-gap: 0;
  }

  &--gradient {
    .ImageOneContainer {
      &::after {
        content: "";
        background: linear-gradient(
          180deg,
          rgba(89, 89, 89, 0) 0%,
          rgba(1, 1, 1, 0.6) 100%
        );
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 75%;
      }
    }
  }
}

.ImageOneContainer {
  position: relative;
  .handle {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.49px;
    position: absolute;
    bottom: 20px;
    left: 20px;
    color: $color-white;
    z-index: 1;
  }
}

.ImageTwoContainer {
  position: relative;
}
.credit {
  bottom: 20px;
  color: $color-white;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.49px;
  left: 20px;
  position: absolute;
}

.title {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50%;
  margin: 0 auto;
  &__text {
    @include t__editorial-headline-20;
    color: $color-white;
  }
  span {
    display: block;
    @include t__editorial-body-10;
  }
}
</style>
